import * as React from 'react';

import styles from './styles.module.scss';

import { Badge } from 'components/ui/badges';

interface AmenitiesRequirementsProps {
    amenities: object[];
    requirements: object[];
}

const AmenitiesRequirements = (props: AmenitiesRequirementsProps) => {
    const { amenities, requirements } = props;

    if (!amenities.length && !requirements.length) {
        return null;
    }
    return (
        <div className={styles.wrapper}>
            <h2>Amenities And Requirements</h2>

            {!!amenities.length && (
                <>
                    <h3>Amenities</h3>
                    <div className={styles.amenities}>{amenities && amenities.map((item, key) => <Badge key={key}>{item}</Badge>)}</div>
                </>
            )}

            {!!requirements.length && (
                <>
                    <h3>Requirements</h3>
                    <div className={styles.requirements}>
                        {requirements && requirements.map((item, key) => <span key={key}>- {item}</span>)}
                    </div>
                </>
            )}
        </div>
    );
};

export default AmenitiesRequirements;
